// This file will help us debug what configuration the React app is actually using
import { Amplify } from "aws-amplify";

// Get the current configuration
const config = Amplify.getConfig();

console.log("=== React App Amplify Configuration ===");
console.log("Full config:", JSON.stringify(config, null, 2));

// Check API configuration specifically
if (config.API?.GraphQL) {
  console.log("GraphQL Config:");
  console.log("- Endpoint:", config.API.GraphQL.endpoint);
  console.log("- Region:", config.API.GraphQL.region);
  console.log("- Default Auth Mode:", config.API.GraphQL.defaultAuthMode);
  console.log("- API Key:", config.API.GraphQL.apiKey);
} else {
  console.log("❌ No GraphQL configuration found");
}

// Check Auth configuration
if (config.Auth?.Cognito) {
  console.log("Auth Config:");
  console.log("- User Pool ID:", config.Auth.Cognito.userPoolId);
  console.log("- User Pool Client ID:", config.Auth.Cognito.userPoolClientId);
} else {
  console.log("❌ No Auth configuration found");
}

export default config;
